export default {
  resetAttrs ({ commit }) {
    commit('setModel', null)
    commit('setName', '')
    commit('setSmallAction', '')
    commit('setDescription', '')
    commit('setAlternateAction', '')
  }
}
